import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "Question-ProfilePage" }
const _hoisted_2 = {
  key: 0,
  class: "header"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add New Question ")
const _hoisted_6 = {
  key: 1,
  class: "header"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { style: {"width":"100%","text-align":"center"} }, " Add New Question profile to create new question. ", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "questionLists",
  ref: "questionLists"
}
const _hoisted_10 = { class: "qNumber" }
const _hoisted_11 = { class: "body" }
const _hoisted_12 = { class: "left" }
const _hoisted_13 = { class: "qlabel" }
const _hoisted_14 = { class: "qtype" }
const _hoisted_15 = { class: "right" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Required ")
const _hoisted_17 = {
  key: 0,
  class: "addNewQuestionSec"
}
const _hoisted_18 = { class: "singleQuestion" }
const _hoisted_19 = { class: "head" }
const _hoisted_20 = { class: "qNumber" }
const _hoisted_21 = { class: "body" }
const _hoisted_22 = { class: "left" }
const _hoisted_23 = { class: "qlabel" }
const _hoisted_24 = { class: "qtype" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Short Text")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Long Text")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Number")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Dropdown")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Radio")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Checkbox")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Datepicker")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Rating")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("File")
const _hoisted_34 = {
  key: 0,
  class: "optionSec"
}
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Options ")
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "addNewOField" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Add Option")
const _hoisted_39 = { class: "right" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Required ")
const _hoisted_41 = { class: "footersec" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Add Question")
const _hoisted_43 = {
  key: 2,
  class: "spinners"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.qProfileName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.qProfileName)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.qProfileName), 1))
            : (_openBlock(), _createElementBlock("h2", _hoisted_4)),
          (_ctx.commonService.checkPermission('Questions', 'create'))
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 2,
                type: "primary",
                block: "",
                class: "newquestionBtn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNewQuestion()))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allQuestions, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "singleQuestion",
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_10, "Question " + _toDisplayString(index + 1), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(item.question), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(item.question_type), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_a_switch, {
                checked: item.active,
                "onUpdate:checked": ($event: any) => ((item.active) = $event),
                onChange: ($event: any) => (_ctx.showEditConfirm(item)),
                disabled: !_ctx.commonService.checkPermission('Questions', 'edit')
              }, null, 8, ["checked", "onUpdate:checked", "onChange", "disabled"]),
              (_ctx.commonService.checkPermission('Questions', 'delete'))
                ? (_openBlock(), _createBlock(_component_CloseOutlined, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.deleteQuestionConfirm(item.id))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128)),
      (_ctx.showNewQuestion)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, "Question " + _toDisplayString(_ctx.allQuestions.length + 1), 1),
                _createVNode(_component_CloseOutlined, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeNewQuestion()))
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_a_form, {
                  ref: "answerFormRef",
                  model: _ctx.answerModal,
                  rules: _ctx.answerFormRules,
                  colon: false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_a_form_item, {
                          label: "",
                          required: "",
                          name: "question"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: "add new question",
                              value: _ctx.answerModal.question,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.answerModal.question) = $event)),
                              type: "text",
                              "allow-clear": ""
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_a_form_item, {
                          label: "",
                          required: "",
                          name: "question_type"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.answerModal.question_type,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.answerModal.question_type) = $event)),
                              placeholder: "Select Field Type",
                              "show-search": "",
                              "filter-option": _ctx.filterOption,
                              onChange: _ctx.onQuestionTypeSelected
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: "Short Text" }, {
                                  default: _withCtx(() => [
                                    _hoisted_25
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "Long Text" }, {
                                  default: _withCtx(() => [
                                    _hoisted_26
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "Number" }, {
                                  default: _withCtx(() => [
                                    _hoisted_27
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "Dropdown" }, {
                                  default: _withCtx(() => [
                                    _hoisted_28
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "Radio" }, {
                                  default: _withCtx(() => [
                                    _hoisted_29
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "Checkbox" }, {
                                  default: _withCtx(() => [
                                    _hoisted_30
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "Datepicker" }, {
                                  default: _withCtx(() => [
                                    _hoisted_31
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "Rating" }, {
                                  default: _withCtx(() => [
                                    _hoisted_32
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: "File" }, {
                                  default: _withCtx(() => [
                                    _hoisted_33
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "filter-option", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      (
                    _ctx.answerModal.question_type === 'Dropdown' ||
                    _ctx.answerModal.question_type === 'Radio' ||
                    _ctx.answerModal.question_type === 'Checkbox'
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("h2", null, [
                              _hoisted_35,
                              (!_ctx.optionFieldValidated)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_36, " (Minimum 2 options required)"))
                                : _createCommentVNode("", true)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionRows, (row, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: row.id,
                                class: "oFields"
                              }, [
                                _createVNode(_component_a_input, {
                                  placeholder: "Options",
                                  value: row.optionValue,
                                  "onUpdate:value": ($event: any) => ((row.optionValue) = $event),
                                  type: "text",
                                  "allow-clear": ""
                                }, null, 8, ["value", "onUpdate:value"]),
                                _createVNode(_component_CloseOutlined, {
                                  onClick: ($event: any) => (_ctx.removeOption(index))
                                }, null, 8, ["onClick"])
                              ]))
                            }), 128)),
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_a_button, {
                                class: "add",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewOptions()))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_38
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createVNode(_component_a_switch, {
                        checked: _ctx.answerModal.required_field,
                        "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.answerModal.required_field) = $event))
                      }, null, 8, ["checked"])
                    ])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_a_button, {
                  class: "add",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveNewQuestion(_ctx.answerModal))),
                  loading: _ctx.addQuestionLoading
                }, {
                  default: _withCtx(() => [
                    _hoisted_42
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 512),
    (_ctx.questionPageLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true)
  ]))
}